<template>
  <b-form-input
    v-model="localValue"
    :id="id"
    :class="getInputClass"
    :name="name"
    :form="form"
    :disabled="disabled"
    :required="required"
    :type="type"
    :size="size"
    :autofocus="autofocus"
    :autocomplete="autocomplete"
    :state="state"
    :aria-invalid="ariaInvalid"
    :trim="trim"
    :placeholder="placeholder"
    :lazy-formatter="lazyFormatter"
    :formatter="formatter"
    :readonly="readonly"
    :plaintext="plaintext"
    :number="number"
    :lazy="lazy"
    :debounce="debounce"
    :no-wheel="noWheel"
    :min="min"
    :max="max"
    :step="step"
    :list="list"
  />
</template>

<script>
import { BFormInput } from 'bootstrap-vue';

export default {
  name: 'MFormInput',
  components: {
    BFormInput,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    form: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'text',
    },
    size: {
      type: String,
      default: null,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    autocomplete: {
      type: String,
      default: null,
    },
    state: {
      type: Boolean,
      default: null,
    },
    ariaInvalid: {
      type: [String, Boolean],
      default: false,
    },
    trim: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: null,
    },
    lazyFormatter: {
      type: Boolean,
      default: false,
    },
    /* eslint-disable vue/require-default-prop */
    formatter: {
      type: Function,
    },
    /* eslint-enable vue/require-default-prop */
    readonly: {
      type: Boolean,
      default: false,
    },
    plaintext: {
      type: Boolean,
      default: false,
    },
    number: {
      type: Boolean,
      default: false,
    },
    lazy: {
      type: Boolean,
      default: false,
    },
    debounce: {
      type: [Number, String],
      default: 0,
    },
    noWheel: {
      type: Boolean,
      default: false,
    },
    min: {
      type: [String, Number],
      default: null,
    },
    max: {
      type: [String, Number],
      default: null,
    },
    step: {
      type: [String, Number],
      default: null,
    },
    list: {
      type: String,
      default: null,
    },
    hasPrefixIcon: {
      type: Boolean,
      default: false,
    },
    hasSuffixIcon: {
      type: Boolean,
      default: false,
    },
    hasDoubleSuffixIcon: {
      type: Boolean,
      default: false,
    },
    clickableReadonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  watch: {
    value(newValue) {
      this.localValue = newValue;
    },
    localValue(newValue) {
      this.$emit('input', newValue);
    },
  },
  computed: {
    getInputClass() {
      return {
        'input-no-readonly': this.clickableReadonly,
        'prefix-icon': this.hasPrefixIcon,
        'suffix-icon': this.hasSuffixIcon,
        'suffix-icon--double': this.hasDoubleSuffixIcon,
      };
    },
  },
};
</script>
